import styled from "styled-components";
import { layout, LayoutProps, space, SpaceProps } from "styled-system";

import { ReactComponent as AppStoreSvg } from "./apple-store-badge.svg";

const Anchor = styled.a<SpaceProps & { css?: string }>`
  display: inline-block;
  ${space}
  ${(props) => props.css}
`;

const StyledSVG = styled(AppStoreSvg)<LayoutProps>`
  ${layout}
`;

export interface AppStoreBadgeProps extends SpaceProps {
  /**
   * Property a url as a string. The url will ne navigated towards in a new window when clicking the badge
   * Example:  https://itunes.apple.com/gb/app/bca-dealer-pro/id1387807489?mt=8
   */
  url: string;
  /**
   *The element's unique identifier
   */
  id?: string;
  /**
   * Property accepts width, value accepted are any css properties plus numbers which will be treated as pixels
   * Examples: "142px", 142, "auto", "100%"
   */
  width?: string | number | (string & (string | number | null)[]);

  css?: string;
  className?: string;
  /**
   * name of the page section in which the element will sit. Used for adobe tracking
   */
  adobeSection?: string;
}

const AppStoreBadge = ({
  width = "142px",
  url,
  adobeSection,
  ...props
}: AppStoreBadgeProps) => (
  <Anchor
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="app-store-badge"
    data-en="click"
    data-ec="button"
    data-el="appStore"
    data-ea="download"
    data-es={adobeSection}
    {...props}
  >
    <StyledSVG title="App Store Badge" width={width} />
  </Anchor>
);

export default AppStoreBadge;
